import { Box, Radio, Stack, Typography } from '@mui/material';
import type { FC } from 'react';
import type { ReportOptionsTileProps } from './ReportOptions.types';

export const ReportOptionTile: FC<ReportOptionsTileProps> = ({ option, isSelected, handleOptionSelect }) => {
  return (
    <Box
      id={`reports_option_${option.title.toLowerCase().replaceAll(' ', '_')}`}
      py={{ xs: 1, md: 2 }}
      px={2}
      boxShadow="0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)"
      borderRadius={1}
      onClick={() => handleOptionSelect(option.id)}
      sx={{ cursor: 'pointer' }}
    >
      <Stack direction="row" spacing={2}>
        <Box>
          <Radio
            color="primary"
            inputProps={{ 'aria-label': option.title }}
            checked={isSelected}
            sx={{
              '& .MuiSvgIcon-root': {
                fontSize: 28
              }
            }}
          />
        </Box>

        <Stack py={1} spacing={1}>
          <Typography component="h3" variant="subtitle2" fontWeight={600}>
            {option.title}
          </Typography>

          <Typography component="p" variant="body1" color="text.secondary">
            {option.description}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};
